module.exports = __webpack_public_path__ + "img/012.6dc29950.jpg";